import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import GameTooltip from './GameTooltip';
import './CDKeyItem.scss';
import {getCurCurrencyOfUnit} from "../../utils/util";

function CDKeyItem({ quest, product}) {
  const {
    cover,
    name,
    headline,
    gallery,
    id,
    releaseDate,
    categories,
  } = quest;

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const formatDate = (date) => {
    if (!date) return ''
    const dateObj = new Date(date)
    const year = dateObj.getFullYear()
    const month = String(dateObj.getMonth() + 1).padStart(2, '0')
    const day = String(dateObj.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
  // Filter the gallery array to include only items with type 'image'
  const imageGallery = gallery?.filter(item => item.type === 'image');

  const galleryExists = imageGallery ? imageGallery.length > 0 : false;
  const [isHovered, setIsHovered] = useState(false);
  const [isRightEdge, setIsRightEdge] = useState(false);
  const itemRef = useRef(null);

  useEffect(() => {
    if (imageGallery) {
      const interval = setInterval(() => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % imageGallery.length);
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [imageGallery?.length]);
  const handleMouseEnter = () => {
    setIsHovered(true);
    if (itemRef.current) {
      const rect = itemRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      console.log('rect.right', rect.right)
      const tooltipWidth = 350; // 你tooltip的大概宽度
      // 如果右边剩余空间不足 tooltipWidth，就往左展开
      setIsRightEdge(viewportWidth - rect.right < tooltipWidth);
    }
  };

  return (
    <div
      ref={itemRef}
      className="cdkey-item-all"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="cdkey-cover-container" data-tip data-for={`tooltip-${id}`}>
        <Link to={`/game/${id}`}>
          <img src={cover} alt="Game Cover" className="cdkey-cover-image" />
        </Link>

      </div>
      <div className="red-line"></div>
      <div className='bottom'>
        <div className="bottom-price">
        <div className='price'>{getCurCurrencyOfUnit(product.currency,product.salePrice)}</div>
          {product.discount>0&&<div className="section-discount">
          <div className="section-block">
            <span className="text-price">{getCurCurrencyOfUnit(product.currency,product.price)}</span>
          </div>
          <span className="text-sale">-{Math.floor(product.discount.toFixed())}%</span>
        </div>}
      </div>
        <div className='remaining'>Stock Left {product&&product.availableNum>999?'999+':product?.availableNum}</div>
      </div>

      {isHovered && <GameTooltip
        isRightEdge={isRightEdge}
        coverPortrait={cover}
        cover={cover}
        errorCover={cover}
        name={name}
        imageGallery={imageGallery}
        currentImageIndex={currentImageIndex}
        galleryExists={galleryExists}
        releaseDate={formatDate(releaseDate)}
        description={headline}
        categories={categories}
      />}
    </div>
  );
}

export default CDKeyItem;
